import { Rsvp } from "../../interfaces/Rsvp.interface";
import { StartingPoint } from "../../interfaces/StartingPoint.interface";
import { RsvpTable } from "./RsvpTable";

interface RsvpProps {
  rsvps: Rsvp[];
  startingPoints: StartingPoint[];
}

export const Rsvps = ({ rsvps, startingPoints }: RsvpProps) => {
  const attendees = rsvps.filter((rsvp) => rsvp.is_attending);
  const nonAttendees = rsvps.filter((rsvp) => !rsvp.is_attending);

  return (
    <div>
      <h2>Attendee List</h2>
      <RsvpTable rsvps={attendees} startingPoints={startingPoints} />

      <h2>Not Attending</h2>
      <RsvpTable rsvps={nonAttendees} />
    </div>
  );
};
